import gql from 'graphql-tag';

export const SearchDispatchSummary = gql`
  query DispatchSummaryTableConnection($input: DispatchSummaryWithCacheConnectionInput) {
    searchDispatchSummary {
      dispatchSummaryTableConnection(input: $input) {
        totalCount
        edges {
          node {
            callVolume
            commentsFaxallCheck
            commentsRepeatDistractedOffenders
            commentsRepeatSpeedingOffenders
            createdAt
            createdBy
            dispatcherAssetCamerasWorking
            dispatcherAssetCamerasWorkingNotes
            dispatcherDayOverview
            dispatcherEightByEightIssue
            dispatcherFirstName
            dispatcherId
            dispatcherLastName
            dispatcherPassdown
            dispatcherServiceIssues
            dispatcherShift
            dispatcherSoftwareIssues
            dispatcherStation
            dispatcherStationVansIssues
            id
            manifestsDrivingIssues
            manifestsTaxis
            manifestsTrainingIssues
            updatedAt
            updatedBy
            chatVolume
            dispatcherWasThereEightByEightIssue
          }
          cursor
        }
        pageInfo {
          startCursor
          endCursor
          hasPreviousPage
          hasNextPage
        }
      }
    }
  }
`;
